import axios from './axios'
export default {
  getOverview: function(data) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${data.campaignId}/insights/overview`,
      { params: data.query }
    )
  },
  getMetricSummary: function(data) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${data.campaignId}/insights/${data.metricType}/summary`,
      { params: data.query }
    )
  },
  getDriverInsight: function(data) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${data.campaignId}/insights/${data.metricType}/drivers`,
      { params: data.query }
    )
  },
  getMetricsTrends: function(data) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${data.campaignId}/insights/${data.metricType}/trends`,
      { params: data.query }
    )
  },
  getResponses: function(campaignId, query) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses`,
      { params: query }
    )
  },
  getResponsesCount: function(campaignId, query) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses/count`,
      { params: query }
    )
  },
  getResponseDetails: function(campaignId, responseId) {
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses/${responseId}`
    )
  },
  deleteResponse: function(campaignId, responseId) {
    return axios.delete(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/responses/${responseId}`
    )
  },
  getStats: function(campaignId){
    return axios.get(
      `/${process.env.VUE_APP_API_VERSION}/campaigns/${campaignId}/stats`
    )
  }
}
